// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { HOST_API_KEY } from '../../config-global';
import { Configuration, LookupData } from '../../@types/configuration';
import { RootState } from '../store';

export const apiSlice = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: HOST_API_KEY,
    prepareHeaders: (headers, { getState }) => {
      // eslint-disable-next-line
      const token = (getState() as RootState).token.token;

      // FIXME Frank: This would be the right place to validate the token and refetch a new one, using "keycloakClient.refreshToken();"

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }

      // eslint-disable-next-line
      const currentSchema = (getState() as RootState).schema.currentSchema;
      if (currentSchema) {
        headers.set('X-TENANT-ID', currentSchema);
      }

      return headers;
    },
  }),
  tagTypes: [
    'School',
    'Student',
    'SchoolCenter',
    'TransportationModel',
    'Place',
    'StudentCalendar',
    'Tour',
    'TourBundle',
    'TourNumber',
    'TourPlan',
    'TransportCompany',
    'Vehicle',
    'SchoolVacationPeriod',
    'SchoolVacationTemplate',
    'SchoolConfig',
    'TransportationPeriod',
    'ConfigLotWithCosts',
    'ExportTypes',
    'ExportGroups',
    'ExportFavorite',
    'TimeMatrix',
    'DefaultTimeManyStudents',
    'TourStops',
    'TourClassVehicleMatrix',
    'Employee',
    'Driver',
    'EmployeeForMessages',
    'InterkommunalerLastenausgleichConfig',
    'TourAll',
    'LocationProviderCreditStatus',
    'EntityDocuments',
    'StudentApplication',
    'TourTender',
    'TourEditData',
    'Roadblock',
    'RoadblockTour',
    'TourClassTime',
    'VehicleTypeCostFee',
    'EntityCostFee',
  ],
  // The "endpoints" represent operations and requests for this server
  endpoints: (builder) => ({
    getConfiguration: builder.query<Configuration, void>({
      query: () => '/config/basic',
    }),
    getLookupData: builder.query<LookupData[], void>({
      query: () => '/lookup',
    }),
    // updatePhoto: builder.mutation<Photo, { id: number; data: Partial<Photo> }>({
    //   query: ({ id, data }) => ({
    //     url: `photos/${id}`,
    //     method: 'PATCH',
    //     body: data,
    //   }),
    // }),
  }),
});

export const {
  useGetConfigurationQuery,
  useGetLookupDataQuery,
  // useUpdatePhotoMutation
} = apiSlice;
